import React from 'react'

const SectionBenefit = () => {
  return (
    <>
      {/* Benefit Section */}
      <section className="section benefit-section bg-light-300">
        <div className="container">
          <div className="row justify-content-center">
            <div
              className="col-lg-6 text-center wow fadeInUp"
              data-wow-delay="0.2s"
            >
              <div className="section-header text-center">
                <h2 className="mb-2">
                  Nossos{" "}
                  <span className="text-primary  text-decoration-underline">
                    Benefícios
                  </span>{" "}
                  e principais vantagens
                </h2>
                <p className="sub-title">
                  A Portugalway, uma operadora de turismo especializada em destinos dos sonhos, oferece uma variedade de benefícios para viajantes.
                </p>
              </div>
            </div>
          </div>
          <div className="row g-4">
            <div className="col-sm-6 col-lg-3 d-flex">
              <div
                className="card benefit-card mb-0 flex-fill wow fadeInUp"
                data-wow-delay="0.2s"
              >
                <div className="card-body text-center">
                  <div className="benefit-icon mb-2 bg-secondary text-gray-9 mx-auto">
                    <i className="isax isax-global" />
                  </div>
                  <h5 className="mb-2">Experiências Autênticas</h5>
                  <p className="mb-0">
                    Fuja do turismo tradicional e descubra o Portugal autêntico! Nossos passeios oferecem experiências genuínas explorando a cultura local, a culinária e lugares secretos.
                  </p>
                  <span className="icon-view text-secondary">
                    <i className="isax isax-lock-1" />
                  </span>
                </div>
              </div>
            </div>
            <div className="col-sm-6 col-lg-3 d-flex">
              <div
                className="card benefit-card mb-0 flex-fill wow fadeInUp"
                data-wow-delay="0.2s"
              >
                <div className="card-body text-center">
                  <div className="benefit-icon mb-2 bg-orange text-white mx-auto">
                    <i className="isax isax-box" />
                  </div>
                  <h5 className="mb-2">Pacotes de Viagens Personalizados</h5>
                  <p className="mb-0">
                    Crie sua viagem sob medida! Escolha sua experiência e nós cuidamos de tudo: hospedagem, transporte e atividades, para uma viagem personalizada e inesquecível.
                  </p>
                  <span className="icon-view text-orange">
                    <i className="isax isax-magicpen" />
                  </span>
                </div>
              </div>
            </div>
            <div className="col-sm-6 col-lg-3 d-flex">
              <div
                className="card benefit-card mb-0 flex-fill wow fadeInUp"
                data-wow-delay="0.2s"
              >
                <div className="card-body text-center">
                  <div className="benefit-icon mb-2 bg-purple text-white mx-auto">
                    <i className="isax isax-car" />
                  </div>
                  <h5 className="mb-2">Conforto e Segurança
                  </h5>
                  <p className="mb-0">
                    Cuidamos de todos os detalhes: transporte confortável, hospedagem selecionada e acompanhamento de guias profissionais, garantindo tranquilidade do início ao fim da viagem.
                  </p>
                  <span className="icon-view text-purple">
                    <i className="isax isax-receipt-add" />
                  </span>
                </div>
              </div>
            </div>
            <div className="col-sm-6 col-lg-3 d-flex">
              <div
                className="card benefit-card mb-0 flex-fill wow fadeInUp"
                data-wow-delay="0.2s"
              >
                <div className="card-body text-center">
                  <div className="benefit-icon mb-2 bg-teal text-white mx-auto">
                    <i className="isax isax-location-tick" />
                  </div>
                  <h5 className="mb-2">Atendimento Dedicado</h5>
                  <p className="mb-0">
                    Desde o primeiro contato até o retorno da sua viagem, você conta com suporte personalizado e uma equipe pronta para atender em português e inglês, com agilidade e atenção total às suas necessidades.
                  </p>
                  <span className="icon-view text-teal">
                    <i className="isax isax-location-tick" />
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* /Benefit Section */}
    </>

  )
}

export default SectionBenefit